import { Coffee } from 'lucide-react';
import { vypocetHodin } from '../spolecne';

/**
 * Editor přestávek směny/šablony. Každá přestávka má čas od–do a příznak placená.
 * Neplacené přestávky se odečítají z odpracovaných hodin (viz vypocetHodin).
 */
export default function PauzyEditor({ pauzy, isDark, mutedColor, iStyle, onChange }) {
    const list = pauzy || [];
    const add = () => onChange([...list, { od: '12:00', do: '12:30', placena: false }]);
    const remove = (i) => onChange(list.filter((_, idx) => idx !== i));
    const upd = (i, patch) => onChange(list.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));

    return (
        <div style={{ padding: '12px 14px', borderRadius: 9, background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderLeft: '3px solid #6B7280' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Coffee size={16} style={{ color: '#6B7280' }} />
                    <span style={{ fontSize: 13, fontWeight: 700, color: isDark ? '#fff' : 'var(--text-primary)' }}>Přestávky</span>
                </div>
                <button type="button" onClick={add}
                    style={{ fontSize: 10, background: '#6B728018', color: '#6B7280', border: 'none', borderRadius: 5, padding: '3px 8px', cursor: 'pointer', fontWeight: 600 }}>
                    + Přestávka
                </button>
            </div>
            <div style={{ fontSize: 11, color: mutedColor, marginBottom: 8 }}>
                Neplacené přestávky se odečítají z odpracovaných hodin.
            </div>

            {list.length === 0 && (
                <div style={{ textAlign: 'center', padding: 10, color: mutedColor, fontSize: 11 }}>Žádné přestávky</div>
            )}

            {list.map((p, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, padding: '6px 8px', borderRadius: 6, background: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
                    <input type="time" value={p.od || ''} onChange={e => upd(i, { od: e.target.value })} style={{ ...iStyle, width: 110 }} title="Začátek přestávky" />
                    <span style={{ color: mutedColor, fontSize: 11 }}>–</span>
                    <input type="time" value={p.do || ''} onChange={e => upd(i, { do: e.target.value })} style={{ ...iStyle, width: 110 }} title="Konec přestávky" />
                    <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: mutedColor, whiteSpace: 'nowrap', marginLeft: 'auto' }}>
                        <input type="checkbox" checked={p.placena || false} onChange={e => upd(i, { placena: e.target.checked })} /> Placená
                    </label>
                    <button type="button" onClick={() => remove(i)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#EF4444', fontSize: 14, flexShrink: 0, padding: 2 }}>✕</button>
                </div>
            ))}
        </div>
    );
}
